import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=5bd4f996&scoped=true"
import script from "./preview-video.vue?vue&type=script&lang=js"
export * from "./preview-video.vue?vue&type=script&lang=js"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=5bd4f996&prod&scoped=true&lang=css"
import style1 from "./preview-video.vue?vue&type=style&index=1&id=5bd4f996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4f996",
  null
  
)

export default component.exports